import ReactLoading from "react-loading";
import React from "react";

export function Loading() {
  return <div className="loading-wrapper">
    <ReactLoading type={"spokes"} color="#959595" width={'100px'} />
  </div>
}